import styled from 'styled-components';

export const DocumentLink = styled.a.attrs({})`
  cursor: pointer;
  color: blue;
  :hover {
    color: #2b102e;
  }
`;
